import React from 'react';
import {MaxPurchaseWarningModal} from './max-purchase-warning';

export interface MaxPurchaseModalProps {
  onClose: () => void;
  children?: never;
}

export const MaxPurchaseModal: React.FC<MaxPurchaseModalProps> = ({
  onClose,
}) => {
  return <MaxPurchaseWarningModal onClose={onClose} />;
};
